import { render, staticRenderFns } from "./MailActive.vue?vue&type=template&id=e5178a62&"
import script from "./MailActive.vue?vue&type=script&lang=js&"
export * from "./MailActive.vue?vue&type=script&lang=js&"
import style0 from "./MailActive.vue?vue&type=style&index=0&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports